module.exports = __webpack_public_path__ + "static/media/05.f7d299de.jpg";